import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'signup-open_fd_sign_up_modal-click';
/**
 * User clicks any CTA to open sign up modal on FD domain
 */
export function trackSignupOpenFdSignUpModalClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
